import { inject, InjectionToken } from '@angular/core';
import { ENVIRONMENT } from '@pinnakl/core/environment';

export type ApiUrlKeys =
  | 'auth'
  | 'authUserInfo'
  | 'createCommunication'
  | 'getCommunicationById'
  | 'getCommunicationByExchangeId'
  | 'communicationTags'
  | 'communicationTag'
  | 'communicationTagAffected'
  | 'communicationNotify'
  | 'crmCommunicationMeeting'
  | 'crmMeetingsActionItems'
  | 'crmMeetingsActionItemsCount'
  | 'crmMeetingsActionItemsBulkUpdate'
  | 'crmMeetingsActionItemsBulkDelete'
  | 'crmMeetingsDashboardSummary'
  | 'crmMeetingsDashboardBreakdowns'
  | 'crmMeetingsDashboardTrends'
  | 'createTask'
  | 'getAiFeatures'
  | 'getOutlookSignatureParserSettings'
  | 'parseEmailSignature'
  | 'search'
  | 'createContact'
  | 'findContactsByEmail'
  | 'getDistributionLists'
  | 'getRelationshipManagers'
  | 'usersV4'
  | 'userRoleV4'
  | 'usersBatchV4'
  | 'userPasswordV4'
  | 'getCrmOptions'
  | 'getCrmOrganizations'
  | 'putCrmOrganizations'
  | 'getLeadChannels'
  | 'getTargetFunds'
  | 'getPipelineStages'
  | 'uploadFile'
  | 'clientFiles'
  | 'clientReportColumns'
  | 'commonCustomAttributes'
  | 'commonCustomAttribute'
  | 'commonCustomAttributesReorder'
  | 'sseTesting'
  | 'clientReports'
  | 'userReports'
  | 'userReport'
  | 'userReportColumns'
  | 'userReportIdcColumns'
  | 'userReportCustomAttributes'
  | 'idcReportingColumns'
  | 'securitiesV4Import'
  | 'assetTypes'
  | 'optionChainLookup'
  | 'idcTickerSearch'
  | 'mapPbIds'
  | 'mapPbId'
  | 'tradesV3'
  | 'omsTradeV4'
  | 'omsTradeV4Allocations'
  | 'omsTradeV4AllocationsRequest'
  | 'tradeComputeTicketElements'
  | 'tradeRequestsLog'
  | 'tradeExecutionReporting'
  | 'complianceTradeRules'
  | 'complianceTradeRule'
  | 'complianceRuleCriteria'
  | 'complianceRtlAccounts'
  | 'complianceRtlAccount'
  | 'complianceTradeRulesAccounts'
  | 'complianceTradeRulesAccount'
  | 'exposureLimitsV3'
  | 'exposureLimitsConfigV3'
  | 'rulesConfigV3'
  | 'customPtcRulesV3'
  | 'complianceExposureLimit'
  | 'complianceCustomRules'
  | 'pbAccounts'
  | 'tradeAllocationSuggestions'
  | 'tradeAuthorizations'
  | 'omsPositions'
  | 'prices'
  | 'price'
  | 'pricingDates'
  | 'priceComments'
  | 'pricingSources'
  | 'pricesCarryOver'
  | 'portfolioWithPrices'
  | 'positionsPnlDataFields'
  | 'extPositions'
  | 'securityPriceTimeseries'
  | 'securityPositionTimeseries'
  | 'securityPriceAlerts'
  | 'securityPriceAlert'
  | 'watchlistItems'
  | 'watchlistItem'
  | 'reconComments'
  | 'reconComment'
  | 'adminIdentifiers'
  | 'adminIdentifier'
  | 'aum'
  | 'accountCashV3'
  | 'omsNavsSod'
  | 'accountsV3'
  | 'globalCurrencies'
  | 'omsConfigV3'
  | 'tradeAllocationsV3'
  | 'tradesFlatV3'
  | 'realtimePortfolioV3'
  | 'securityPriceTimeseriesV3'
  | 'positionTimeseriesV3'
  | 'tradeAllocationRatios'
  | 'stockLoanWatchLists'
  | 'stockLoanWatchList'
  | 'stockLoanWatchListFinancialInstitutionActivate'
  | 'stockLoanWatchListFinancialInstitutionDeactivate'
  | 'stockLoanRequests'
  | 'stockLoanRequest'
  | 'stockLoanCounterparties'
  | 'securityMarketDetails'
  | 'securityMarketBatchDetails'
  | 'securityMarketsForSecurity'
  | 'securityTypesV3'
  | 'securitiesStatsByAssetTypes'
  | 'securitySharesOutstanding'
  | 'restrictedTrades'
  | 'restrictedTrade'
  | 'securityOrganizations'
  | 'securityOrganization'
  | 'securitiesV4'
  | 'securityV4'
  | 'securityAffectedTrades'
  | 'securityOrganizationIssuedSecurities'
  | 'securityOrganizationIssuedSecurity'
  | 'securityOrganizationIssuedSecurityAssetTypes'
  | 'securityOptionDetails'
  | 'securityFutureDetails'
  | 'securityBondDetails'
  | 'bondCouponTypes'
  | 'bondInterestBasis'
  | 'bondPaymentFrequencies'
  | 'securityMarketDividends'
  | 'securityDividendTypes'
  | 'securityDividendFrequencies'
  | 'assetTypesV3'
  | 'sapiAuth'
  | 'sapiAuthStatus'
  | 'rebalancingCalculate'
  | 'rebalanceTemplates'
  | 'rebalanceTemplate'
  | 'rebalancings'
  | 'rebalancing'
  | 'rebalancingPortfolioWeights'
  | 'rebalancingsPending'
  | 'rebalancingCalculateAndSaveSecuritiesQuantity'
  | 'rebalancingCalculateAndSaveSecurityTargetPct'
  | 'rebalancingCalculateAndSavePortfolio'
  | 'rebalancingSaveInputs'
  | 'rebalancingStage'
  | 'rebalancingCompleted'
  | 'rebalancingCashBalance'
  | 'rebalancingNavsWithExposure'
  | 'rebalancingUserSettingsV3'
  | 'pricingRealtimePriceOverrides'
  | 'pricingRealtimePriceOverride'
  | 'pricingClosePriceOverride'
  | 'benchmarkIndexIntradayPerformanceV3'
  | 'benchmarkAccountIntradayPerformanceV3'
  | 'positionBaseV3'
  | 'pmsRebalanceConfigV3'
  | 'pmsUserSettingsV3'
  | 'pmsPositionsV3'
  | 'portfolioLatestPricesV3'
  | 'pnlDiffPerSecurity'
  | 'pmsColumns'
  | 'boxedPositions'
  | 'pmsAccountCashLatest'
  | 'performanceTableAggregated'
  | 'performanceTableDetailed'
  | 'performanceSummary'
  | 'performanceNavChangeDetails'
  | 'orders'
  | 'order'
  | 'ordersSearch'
  | 'ordersBulkRouting'
  | 'placements'
  | 'placement'
  | 'orderAllocations'
  | 'orderAllocationsV3'
  | 'omsTrades'
  | 'omsTrade'
  | 'omsTradesSearch'
  | 'omsConfig'
  | 'positionReconciliation'
  | 'counterparties'
  | 'counterparty'
  | 'counterpartyCustodians'
  | 'marketsV3'
  | 'marketMostRecentFolder'
  | 'folderValues'
  | 'folderValue'
  | 'folderValueAffectedTrades'
  | 'folderDefinitions'
  | 'folderDefinition'
  | 'folderDefinitionOptions'
  | 'folderDefinitionOptionAffectedFolders'
  | 'omsFolderComments'
  | 'omsFolderComment'
  | 'folderCommentsV3'
  | 'folderCommentV3'
  | 'securityMarketQuote'
  | 'pmsQuantitiesWeights'
  | 'pmsQuantitiesTargets'
  | 'emsUserSettingsV3'
  | 'emsOrderPtcValidate'
  | 'emsOrderHotkeys'
  | 'emsOrderHotkey'
  | 'emsConfig'
  | 'folderConcept'
  | 'configurationOmsConfig'
  | 'cashBalancesEod'
  | 'cashBalanceEod'
  | 'cashBalancesAdjustment'
  | 'configurationAumsEod'
  | 'configurationAumEod'
  | 'brokersV3'
  | 'brokerV3'
  | 'brokersV4'
  | 'brokerCommissionSchedules'
  | 'brokerCommissionSchedule'
  | 'brokerCommissionScheduleRules'
  | 'brokerCommissionScheduleRule'
  | 'brokerIdentificationIds'
  | 'brokerIdentificationId'
  | 'brokerIdentificationTypes'
  | 'brokerMatchingCommissions'
  | 'commissionSchedulePredicatesV3'
  | 'brokerOutsourcedDestinationsV3'
  | 'brokerOutsourcedDestinationV3'
  | 'brokerEmails'
  | 'brokerEmail'
  | 'countries'
  | 'country'
  | 'fxRatesCurrenciesLatestV3'
  | 'crmIrAccountingFundsAum'
  | 'crmIrAccountingFundsAumAll'
  | 'crmIrAccountingFundsAumItem'
  | 'crmIrAccountingFundAumPartitions'
  | 'crmIrAccountingFundsAumSearch'
  | 'crmIrAccountingFunds'
  | 'crmIrAccountingFund'
  | 'crmIrAccountingFundAffected'
  | 'crmIrFeeTerms'
  | 'crmIrFeeTerm'
  | 'crmIrFeeTermAffected'
  | 'crmIrDashboard'
  | 'crmIrMonthlyAccountData'
  | 'crmIrMonthlyAccountDataMostRecent'
  | 'crmTargetFunds'
  | 'crmTargetFundSummary'
  | 'crmTargetFundReturns'
  | 'crmTargetFundReturn'
  | 'crmTargetFundReturnsDistribution'
  | 'crmFundPerformanceBenchmarks'
  | 'crmFundPerformanceBenchmarksAll'
  | 'crmFundPerformanceBenchmarksClient'
  | 'crmFundPerformanceBenchmarkReturns'
  | 'crmFundPerformanceStatsBenchmarks'
  | 'crmFundPerformanceStatsTargetFunds'
  | 'dedicatedInvestorPortalHome'
  | 'wikiTags'
  | 'wikiTag'
  | 'wikiNotes'
  | 'wikiNote'
  | 'wikiNoteCategory'
  | 'wikiNoteTags'
  | 'wikiNoteTargetFunds'
  | 'wikiCategories'
  | 'wikiCategory'
  | 'crmTaskSuggestions'
  | 'crmTaskSuggestion'
  | 'crmTaskSuggestionTasks'
  | 'crmTaskSuggestionsByIds'
  | 'crmTasks'
  | 'crmTask'
  | 'crmTasksSearch'
  | 'crmSubTasks'
  | 'crmSubTask'
  | 'crmTargetFund'
  | 'crmTargetFundAffectedInvestors'
  | 'crmStatusTypes'
  | 'crmStatusType'
  | 'crmStatusTypeAffectedInvestors'
  | 'crmWorkspaces'
  | 'crmOrganizations'
  | 'crmOrganization'
  | 'crmOrganizationCommunicationTotals'
  | 'crmOrganizationsPaged'
  | 'crmOrganizationsBulkUpdate'
  | 'crmOrganizationsBulkUpdateByQuery'
  | 'crmOrganizationsByCreatedDate'
  | 'crmOrganizationsByQuery'
  | 'crmOrganizationsMerge'
  | 'crmV4Organization'
  | 'crmOrganizationSummaries'
  | 'crmOrganizationGenerateSummary'
  | 'crmOrganizationAiSummary'
  | 'crmOrganizationContactAiSummary'
  | 'crmOrganizationContactGenerateSummary'
  | 'crmAiChatDataSources'
  | 'crmOrganizationAiChats'
  | 'crmOrganizationAiChat'
  | 'crmOrganizationAiChatMessages'
  | 'crmOrganizationContacts'
  | 'crmOrganizationContact'
  | 'crmOrganizationContactPrimary'
  | 'crmOrganizationRelationships'
  | 'crmOrganizationRelationship'
  | 'crmOrganizationLinkedRelationships'
  | 'crmOrganizationLinkedRelationship'
  | 'crmOrganizationInvestorTypes'
  | 'crmOrganizationInvestorType'
  | 'crmOrganizationInvestorTypeStats'
  | 'crmOrganizationDocuments'
  | 'crmOrganizationHistoricalTotalBalances'
  | 'crmOrganizationCampaignSentActivity'
  | 'crmOrganizationCampaignOpenActivity'
  | 'crmOrganizationCampaignClickActivity'
  | 'crmOrganizationAuditTrail'
  | 'crmOrganizationGpDetails'
  | 'crmOrganizationGpFunds'
  | 'crmOrganizationGpFund'
  | 'crmGpFundStatuses'
  | 'crmGpFundDomicileJurisdictions'
  | 'crmGpFundLegalStructures'
  | 'crmContactsV3'
  | 'crmContactV3'
  | 'crmContactCommunicationTotals'
  | 'crmContactCampaignSentActivity'
  | 'crmContactCampaignOpenActivity'
  | 'crmContactCampaignClickActivity'
  | 'crmContactCollectCommunications'
  | 'crmContactCollectCommunicationsPreview'
  | 'crmContactsPaged'
  | 'crmContactsCount'
  | 'crmContactsRecentlyCreated'
  | 'crmContactsMerge'
  | 'crmContactsLegacy'
  | 'crmPhones'
  | 'crmEmailAddresses'
  | 'crmContactsProximitySearch'
  | 'crmContactRelatedInvestorAccounts'
  | 'crmContactsMigrate'
  | 'crmContactAuditTrail'
  | 'crmInvestors'
  | 'crmRecentlyVisitedInvestors'
  | 'crmInvestorStatusTypes'
  | 'crmClientInvestorReturnMappingV3'
  | 'crmInvestorPostalAddresses'
  | 'crmInvestorContacts'
  | 'crmInvestorContact'
  | 'crmDakotaContacts'
  | 'crmDakotaOrganizations'
  | 'crmDakotaOrganizationsBatch'
  | 'crmDakotaFieldOptions'
  | 'crmDakotaFieldOptionsNames'
  | 'crmOrganizationMonthlyBalancesSearch'
  | 'crmOrganizationMigrations'
  | 'crmOrganizationInvestorAccounts'
  | 'crmOrganizationCapitalActivitySearch'
  | 'crmIrCapitalActivities'
  | 'crmIrCapitalActivity'
  | 'crmIrCapitalActivityFile'
  | 'crmIrCapitalActivitiesSearch'
  | 'crmIrCapitalActivityTransactionTypes'
  | 'crmIrCapitalActivityTransactionType'
  | 'crmIrCapitalActivityTransactionTypeCanDelete'
  | 'crmIrSideLetterCategories'
  | 'crmIrSideLetterCategory'
  | 'crmIrSideLetterCategoryClauses'
  | 'crmIrSideLetterCategoryClause'
  | 'crmIrSideLetterTriggers'
  | 'crmIrSideLetterTrigger'
  | 'crmIrSideLetterClauseTriggers'
  | 'crmIrSideLetterClauseNotifications'
  | 'crmIrSideLetterNotification'
  | 'crmIrInvestorAccounts'
  | 'crmIrInvestorAccount'
  | 'crmIrInvestorAccountsPaged'
  | 'crmIrInvestorAccountMigration'
  | 'crmIrInvestorAccountContacts'
  | 'crmIrInvestorAccountContact'
  | 'crmInvestorAccountRegulatoryFillingsV3'
  | 'crmInvestorAccountAmlV3'
  | 'crmInvestorAccountTaxV3'
  | 'crmRegAmlFieldOptionsV3'
  | 'crmInvestorAccountTaxFieldOptionsV3'
  | 'crmIrMonthlyBalanceColumns'
  | 'crmIrMonthlyBalances'
  | 'crmIrMonthlyBalancesCount'
  | 'crmIrMonthlyBalancesSearch'
  | 'crmSearchRecent'
  | 'crmSearchRecentItem'
  | 'bulkUploadImport'
  | 'bulkUploadImportTemplates'
  | 'bulkUploadImportFile'
  | 'bulkUploadImportFileRevert'
  | 'bulkUploadImportFileProcess'
  | 'crmEmailCampaignTrackingLinksV4'
  | 'crmEmailCampaignTrackingLinkV4'
  | 'crmEmailCampaignTemplates'
  | 'crmEmailCampaignTemplate'
  | 'crmEmailCampaigns'
  | 'crmEmailCampaign'
  | 'crmEmailCampaignTabsCount'
  | 'crmEmailCampaignValidate'
  | 'crmEmailCampaignTest'
  | 'crmEmailCampaignSend'
  | 'crmEmailCampaignSchedule'
  | 'crmEmailCampaignDocuments'
  | 'crmEmailCampaignDocument'
  | 'crmEmailCampaignContacts'
  | 'crmEmailCampaignContactsIncludedPaged'
  | 'crmEmailCampaignContactsRemovedPaged'
  | 'crmEmailCampaignContactsAvailablePaged'
  | 'crmEmailCampaignContactsInclude'
  | 'crmEmailCampaignContactsExclude'
  | 'crmEmailCampaignContactsRemovedClear'
  | 'crmEmailCampaignContactEngagement'
  | 'crmEmailCampaignCategories'
  | 'crmEmailCampaignCategory'
  | 'crmEmailCampaignCategoryAffected'
  | 'crmEmailCampaignTesters'
  | 'crmEmailCampaignTester'
  | 'crmEmailCampaignDistributionLists'
  | 'crmEmailCampaignDistributionList'
  | 'crmEmailCampaignDistributionListDuplicate'
  | 'crmEmailCampaignDistributionListContacts'
  | 'crmEmailCampaignDistributionListContactsBulkUpdateByQuery'
  | 'crmLegacyDistributionList'
  | 'crmSentEmailCampaign'
  | 'crmSentEmailCampaignOpenActivity'
  | 'crmSentEmailCampaignClickActivity'
  | 'crmSentEmailCampaignSummaryStats'
  | 'crmDeals'
  | 'crmDeal'
  | 'crmDealRelatedOrganization'
  | 'crmDealPipelines'
  | 'crmDealPipeline'
  | 'crmDealPipelineStats'
  | 'crmDealPipelineDeals'
  | 'crmDealPipelineStages'
  | 'crmDealPipelineStage'
  | 'crmDealPipelineStagesReorder'
  | 'crmDealLossReasons'
  | 'crmDealLossReason'
  | 'crmDealLossReasonAffectedDeals'
  | 'crmGpDropdownOptions'
  | 'crmGpDropdownOption'
  | 'crmGpDropdownOptionTypes'
  | 'crmDashboardEntitiesCount'
  | 'crmDashboardPortalAnalyticsSummary'
  | 'crmDashboardChartingFields'
  | 'crmDashboardOrganizationsCountStaticField'
  | 'crmDashboardOrganizationsCountCustomField'
  | 'crmDashboardRecentEmailCampaignStats'
  | 'crmDashboardActivitySummary'
  | 'crmDashboardDealsSummary'
  | 'crmDashboardOrganizationCategoryDetails'
  | 'crmDashboardCountries'
  | 'leadChannel'
  | 'leadChannelAffectedInvestors'
  | 'sectorsV4'
  | 'securityPublicIdentifiers'
  | 'securityOrganizationStatuses'
  | 'securityOrganizationStatus'
  | 'authEmailsCollector'
  | 'statusEmailsCollector'
  | 'revokeEmailCollector'
  | 'securityCustomAttributes'
  | 'securityCustomAttribute'
  | 'portalUser'
  | 'portalUserClientConfig'
  | 'portalUserSelectedClient'
  | 'cashFlows'
  | 'cashFlow'
  | 'cashFlowTypes'
  | 'corporateActionEvents'
  | 'corporateActionEvent'
  | 'corporateActionEventProcessing'
  | 'corporateActionEventResults'
  | 'corporateActionEventResult'
  | 'corporateActionEventSources'
  | 'corporateActionEventTypes'
  | 'dashboardAllData'
  | 'dashboardActivitySummary'
  | 'dashboardTasks'
  | 'dashboardTaskParams'
  | 'dashboardTaskRequests'
  | 'dashboardTaskStatusDetails'
  | 'dashboardTaskStatus'
  | 'recommendedActions'
  | 'recommendedActionActivities'
  | 'bulkTradeUpload'
  | 'benchmarkComparisons'
  | 'counterPartyExposure'
  | 'riskDates'
  | 'riskDashboard'
  | 'riskExposureFields'
  | 'riskLimits'
  | 'riskTimeseries'
  | 'riskClientBenchmarks'
  | 'riskStressTests'
  | 'riskPortfolioCharacteristics'
  | 'tradeRestrictionPredicates'
  | 'generalLedgerAccounts'
  | 'generalLedgerJournalItems'
  | 'generalLedgerChanges'
  | 'generalLedgerRecurringExpenses'
  | 'clients'
  | 'presets'
  | 'preset'
  | 'reports'
  | 'reportColumns'
  | 'reportParameters'
  | 'vdrPortalUsers'
  | 'vdrPortalUsersActivate'
  | 'vdrPortalUsersDeactivate'
  | 'vdrPortalGroups'
  | 'vdrPortalGroup'
  | 'vdrRootFolders'
  | 'dataRoomPortalDocuments'
  | 'dataRoomPortalDocument'
  | 'dataRoomPortalRecentDocuments'
  | 'dataRoomPortalDocumentsSearch'
  | 'dataRoomPortalDocumentNotificationRecipients'
  | 'dataRoomDocumentNotifications'
  | 'dataRoomFolders'
  | 'dataRoomFolder'
  | 'dataRoomFolderAccess'
  | 'dataRoomFolderFile'
  | 'dataRoomFolderFileDetails'
  | 'crmEmailCampaignTrackingLinks'
  | 'dataRooms'
  | 'dataRoomsExternal'
  | 'dataRoomsEmailCampaign'
  | 'dataRoom'
  | 'crmPortalConfigs'
  | 'crmPortalConfig'
  | 'vdrAnalyticsSummary'
  | 'vdrAnalyticsActivitiesCount'
  | 'vdrAnalyticsMostEngagedUsers'
  | 'vdrAnalyticsMostEngagedOrganizations'
  | 'vdrAnalyticsMostPopularDocuments'
  | 'vdrAnalyticsMostPopularFolders'
  | 'vdrAnalyticsUserActivities'
  | 'vdrAnalyticsContact'
  | 'vdrAnalyticsOrganization'
  | 'vdrAnalyticsActivityCount'
  | 'vdrAnalyticsUser'
  | 'vdrAnalyticsDocument'
  | 'watermarkSettingsTemplates'
  | 'watermarkSettingsTemplate'
  | 'watermarkSettingsTemplateCanDelete'
  | 'watermarkSettingsDefault'
  | 'watermarkSettingsFonts'
  | 'vdrConfiguration'
  | 'notificationTopics'
  | 'notificationSubscribers'
  | 'notificationSubscriber'
  | 'notificationSubscriberSubscriptions'
  | 'teams'
  | 'team'
  | 'teamUsers'
  | 'teamUser'
  | 'internalEmployees'
  | 'internalEmployee'
  | 'internalEmployeeCanDelete'
  | 'domainExclusions'
  | 'emailExclusions'
  | 'emailCampaignClientConfiguration'
  | 'localitiesV3'
  | 'crmClientConfig'
  | 'crmOutlookAddinConfig'
  | 'crmCanDisableMultipleAssignees'
  | 'emailCampaignConfig'
  | 'emailProviderIntegrationTest'
  | 'blockedIps'
  | 'blockedIp'
  | 'allUsers'
  | 'aiFeatures'
  | 'aiFeaturesDisclaimer'
  | 'aiFeaturesEnabled'
  | 'aiFeaturesDisabled'
  | 'aiTokenUsagesSummary'
  | 'aiAgentSettings'
  | 'aiAgentSetting'
  | 'userModuleConfigsV4'
  | 'userModuleConfigV4'
  | 'shareUserModuleConfigsV4';

export type ApiUrls = Record<ApiUrlKeys, string>;

export const API_URLS = new InjectionToken<ApiUrls>('API_URLS', {
  providedIn: 'root',
  factory: (): ApiUrls => {
    const {
      coreApiServerUrl: environmentCoreApiServerUrl,
      fileServiceUrl,
      emailsCollectorUrl,
      httpServerUrl,
      pinnaklApiUrl,
      authConfig,
      authApiServerUrl,
    } = inject(ENVIRONMENT);

    const coreApiServerUrl = environmentCoreApiServerUrl ?? httpServerUrl;

    return {
      auth: `${authApiServerUrl ?? coreApiServerUrl}/auth`,
      authUserInfo: `${authConfig?.authority}/connect/userinfo`,
      createCommunication: `${coreApiServerUrl}/v4/crm/communications`,
      getCommunicationById: `${coreApiServerUrl}/v4/crm/communications/{id}`,
      getCommunicationByExchangeId: `${coreApiServerUrl}/v4/crm/communications/exchange`,
      communicationTags: `${coreApiServerUrl}/v4/crm/communications/tags`,
      communicationTag: `${coreApiServerUrl}/v4/crm/communications/tags/{id}`,
      communicationTagAffected: `${coreApiServerUrl}/v4/crm/communications/tags/{id}/affected`,
      communicationNotify: `${coreApiServerUrl}/v4/crm/communications/notify`,
      crmCommunicationMeeting: `${coreApiServerUrl}/v4/crm/communications/{communicationId}/meeting`,
      crmMeetingsActionItems: `${coreApiServerUrl}/v4/crm/meetings/action-items`,
      crmMeetingsActionItemsCount: `${coreApiServerUrl}/v4/crm/meetings/action-items/count`,
      crmMeetingsActionItemsBulkUpdate: `${coreApiServerUrl}/v4/crm/meetings/action-items/bulk-update`,
      crmMeetingsActionItemsBulkDelete: `${coreApiServerUrl}/v4/crm/meetings/action-items/bulk-delete`,
      crmMeetingsDashboardSummary: `${coreApiServerUrl}/v4/crm/meetings/dashboard/summary`,
      crmMeetingsDashboardBreakdowns: `${coreApiServerUrl}/v4/crm/meetings/dashboard/breakdowns`,
      crmMeetingsDashboardTrends: `${coreApiServerUrl}/v4/crm/meetings/dashboard/trends`,
      createTask: `${coreApiServerUrl}/v4/crm/tasks`,
      parseEmailSignature: `${coreApiServerUrl}/v4/crm/parse-email-signature`,
      getAiFeatures: `${coreApiServerUrl}/v4/crm/ai-features`,
      getOutlookSignatureParserSettings: `${coreApiServerUrl}/v4/crm/ai-agents/settings/OutlookSignatureParser`,
      search: `${coreApiServerUrl}/v4/crm/search`,
      createContact: `${coreApiServerUrl}/v3/entities/contacts`,
      findContactsByEmail: `${coreApiServerUrl}/v3/entities/crm_find_contacts_by_email`,
      getDistributionLists: `${coreApiServerUrl}/entities/crm_dist_lists`,
      getRelationshipManagers: `${coreApiServerUrl}/v4/clients/crm-employees`,
      usersV4: `${coreApiServerUrl}/v4/users`,
      userRoleV4: `${coreApiServerUrl}/v4/users/{userId}/roles/{role}`,
      usersBatchV4: `${coreApiServerUrl}/v4/users/batch`,
      userPasswordV4: `${coreApiServerUrl}/v4/users/password`,
      getCrmOptions: `${coreApiServerUrl}/v3/entities/crm_options`,
      getCrmOrganizations: `${coreApiServerUrl}/v3/entities/crm_organizations/{id}`,
      putCrmOrganizations: `${coreApiServerUrl}/v3/entities/crm_organizations`,
      getLeadChannels: `${coreApiServerUrl}/v4/crm/lead-channels`,
      getTargetFunds: `${coreApiServerUrl}/v4/crm/target-funds`,
      getPipelineStages: `${coreApiServerUrl}/v4/crm/status-types`,
      uploadFile: `${fileServiceUrl}/Upload`,
      clientFiles: `${coreApiServerUrl}/entities/client_files`,
      clientReportColumns: `${coreApiServerUrl}/v4/client-reports/{clientReportId}/columns`,
      commonCustomAttributes: `${coreApiServerUrl}/v4/entities/custom-attributes/{feature}`,
      commonCustomAttribute: `${coreApiServerUrl}/v4/entities/custom-attributes/{feature}/{id}`,
      commonCustomAttributesReorder: `${coreApiServerUrl}/v4/entities/custom-attributes/{feature}/reorder`,
      sseTesting: `${coreApiServerUrl}/entities/sse_testing`,
      clientReports: `${coreApiServerUrl}/v4/client-reports`,
      userReports: `${coreApiServerUrl}/v4/user-reports`,
      userReport: `${coreApiServerUrl}/v4/user-reports/{id}`,
      userReportColumns: `${coreApiServerUrl}/v4/user-reports/{userReportId}/columns`,
      userReportIdcColumns: `${coreApiServerUrl}/v4/user-reports/{userReportId}/idc-columns`,
      userReportCustomAttributes: `${coreApiServerUrl}/v4/user-reports/{userReportId}/custom-attributes`,
      idcReportingColumns: `${coreApiServerUrl}/v4/reports/idc-columns`,
      securitiesV4Import: `${coreApiServerUrl}/v4/entities/securities/import`,
      assetTypes: `${coreApiServerUrl}/entities/asset_types`,
      optionChainLookup: `${coreApiServerUrl}/v3/entities/option_chain_lookup`,
      idcTickerSearch: `${coreApiServerUrl}/entities/idc_ticker_search`,
      mapPbIds: `${coreApiServerUrl}/entities/mappbid`,
      mapPbId: `${coreApiServerUrl}/entities/mappbid/{id}`,
      tradesV3: `${coreApiServerUrl}/v3/entities/trades`,
      omsTradeV4: `${coreApiServerUrl}/v4/trades/{id}`,
      omsTradeV4Allocations: `${coreApiServerUrl}/v4/trades/{id}/allocations`,
      omsTradeV4AllocationsRequest: `${coreApiServerUrl}/v4/trades/{id}/allocations-request`,
      tradeComputeTicketElements: `${coreApiServerUrl}/v4/trades/compute-ticket-elements`,
      tradeRequestsLog: `${coreApiServerUrl}/entities/trade_requests_log`,
      tradeExecutionReporting: `${coreApiServerUrl}/entities/trade_execution_reporting`,
      complianceTradeRules: `${coreApiServerUrl}/entities/compliance_trade_rules`,
      complianceTradeRule: `${coreApiServerUrl}/entities/compliance_trade_rules/{id}`,
      complianceRuleCriteria: `${coreApiServerUrl}/entities/compliance_rule_criteria`,
      complianceRtlAccounts: `${coreApiServerUrl}/entities/compliance_rtl_accounts`,
      complianceRtlAccount: `${coreApiServerUrl}/entities/compliance_rtl_accounts/{id}`,
      complianceTradeRulesAccounts: `${coreApiServerUrl}/entities/compliance_trade_rules_accounts`,
      complianceTradeRulesAccount: `${coreApiServerUrl}/entities/compliance_trade_rules_accounts/{id}`,
      exposureLimitsV3: `${coreApiServerUrl}/v3/entities/exposure_limits`,
      exposureLimitsConfigV3: `${coreApiServerUrl}/v3/entities/exposure_limits_config`,
      rulesConfigV3: `${coreApiServerUrl}/v3/entities/rules_config`,
      customPtcRulesV3: `${coreApiServerUrl}/v3/entities/custom_ptc_rules`,
      complianceExposureLimit: `${coreApiServerUrl}/entities/compliance_exposure_limits/{id}`,
      complianceCustomRules: `${coreApiServerUrl}/entities/compliance_custom_rules`,
      pbAccounts: `${coreApiServerUrl}/entities/pbaccounts`,
      tradeAllocationSuggestions: `${coreApiServerUrl}/v4/oms/trade-allocation-ratios/allocation-suggestions`,
      tradeAuthorizations: `${coreApiServerUrl}/entities/trade_authorizations`,
      omsPositions: `${coreApiServerUrl}/entities/omspositions`,
      prices: `${coreApiServerUrl}/entities/prices`,
      price: `${coreApiServerUrl}/entities/prices/{id}`,
      pricingDates: `${coreApiServerUrl}/entities/pricing_dates`,
      priceComments: `${coreApiServerUrl}/entities/price_comments`,
      pricingSources: `${coreApiServerUrl}/entities/pricing_sources`,
      pricesCarryOver: `${coreApiServerUrl}/entities/prices_carry_over`,
      portfolioWithPrices: `${coreApiServerUrl}/entities/portfolio_with_prices`,
      positionsPnlDataFields: `${coreApiServerUrl}/entities/positions_pnl_data_fields`,
      extPositions: `${coreApiServerUrl}/entities/extpos`,
      securityPriceTimeseries: `${coreApiServerUrl}/entities/security_price_timeseries`,
      securityPositionTimeseries: `${coreApiServerUrl}/entities/security_position_timeseries`,
      securityPriceAlerts: `${coreApiServerUrl}/v3/entities/security_price_alerts`,
      securityPriceAlert: `${coreApiServerUrl}/v3/entities/security_price_alerts/{id}`,
      watchlistItems: `${coreApiServerUrl}/v3/entities/watchlist_items`,
      watchlistItem: `${coreApiServerUrl}/v3/entities/watchlist_items/{id}`,
      reconComments: `${coreApiServerUrl}/entities/recon_comments`,
      reconComment: `${coreApiServerUrl}/entities/recon_comments/{id}`,
      adminIdentifiers: `${coreApiServerUrl}/entities/admin_identifiers`,
      adminIdentifier: `${coreApiServerUrl}/entities/admin_identifiers/{id}`,
      aum: `${coreApiServerUrl}/entities/aum`,
      accountCashV3: `${coreApiServerUrl}/v3/entities/account_cash`,
      omsNavsSod: `${coreApiServerUrl}/v4/oms/navs/sod`,
      accountsV3: `${coreApiServerUrl}/v3/entities/accounts`,
      globalCurrencies: `${coreApiServerUrl}/v3/entities/global_currencies`,
      omsConfigV3: `${coreApiServerUrl}/v3/entities/oms_config`,
      tradeAllocationsV3: `${coreApiServerUrl}/v3/entities/trade_allocations`,
      tradesFlatV3: `${coreApiServerUrl}/v3/entities/trades_flat`,
      realtimePortfolioV3: `${coreApiServerUrl}/v3/entities/realtime_portfolio`,
      securityPriceTimeseriesV3: `${coreApiServerUrl}/v3/entities/security_price_timeseries_v3`,
      positionTimeseriesV3: `${coreApiServerUrl}/v3/entities/position_timeseries`,
      tradeAllocationRatios: `${coreApiServerUrl}/v4/oms/trade-allocation-ratios`,
      stockLoanWatchLists: `${coreApiServerUrl}/v4/stockloan/watchlist`,
      stockLoanWatchList: `${coreApiServerUrl}/v4/stockloan/watchlist/{id}`,
      stockLoanWatchListFinancialInstitutionActivate: `${coreApiServerUrl}/v4/stockloan/watchlist/{listId}/financialInstitutions/{financialInstitutionId}/activate`,
      stockLoanWatchListFinancialInstitutionDeactivate: `${coreApiServerUrl}/v4/stockloan/watchlist/{listId}/financialInstitutions/{financialInstitutionId}/deactivate`,
      stockLoanRequests: `${coreApiServerUrl}/v4/stockloan/requests`,
      stockLoanRequest: `${coreApiServerUrl}/v4/stockloan/requests/{id}`,
      stockLoanCounterparties: `${coreApiServerUrl}/v4/oms/counterparties/stock-loan`,
      securityMarketDetails: `${coreApiServerUrl}/v4/entities/security-markets/{securityMarketId}`,
      securityMarketBatchDetails: `${coreApiServerUrl}/v4/entities/security-markets/batch`,
      securityMarketsForSecurity: `${coreApiServerUrl}/v4/entities/securities/{securityId}/markets`,
      securityTypesV3: `${coreApiServerUrl}/v3/entities/security_types`,
      securitiesStatsByAssetTypes: `${coreApiServerUrl}/v4/entities/securities/stats-by-asset-types`,
      securitySharesOutstanding: `${coreApiServerUrl}/v4/entities/securities/{securityId}/shares-outstanding`,
      restrictedTrades: `${coreApiServerUrl}/v4/entities/securities/restricted-trading-list`,
      restrictedTrade: `${coreApiServerUrl}/v4/entities/securities/restricted-trading-list/{id}`,
      securityOrganizations: `${coreApiServerUrl}/v4/entities/securities/orgs`,
      securityOrganization: `${coreApiServerUrl}/v4/entities/securities/orgs/{id}`,
      securitiesV4: `${coreApiServerUrl}/v4/entities/securities`,
      securityV4: `${coreApiServerUrl}/v4/entities/securities/{id}`,
      securityAffectedTrades: `${coreApiServerUrl}/v4/entities/securities/{securityId}/affected-trades`,
      securityOrganizationIssuedSecurities: `${coreApiServerUrl}/v4/entities/securities/orgs/{orgId}/issued-securities`,
      securityOrganizationIssuedSecurity: `${coreApiServerUrl}/v4/entities/securities/orgs/{orgId}/issued-securities/{id}`,
      securityOrganizationIssuedSecurityAssetTypes: `${coreApiServerUrl}/v4/entities/securities/orgs/{id}/issued-securities/asset-types`,
      securityOptionDetails: `${coreApiServerUrl}/v4/entities/securities/{securityId}/option-details`,
      securityFutureDetails: `${coreApiServerUrl}/v4/entities/securities/{securityId}/future-details`,
      securityBondDetails: `${coreApiServerUrl}/v4/entities/securities/{securityId}/bond-details`,
      bondCouponTypes: `${coreApiServerUrl}/v4/entities/securities/bond-details/coupon-types`,
      bondInterestBasis: `${coreApiServerUrl}/v4/entities/securities/bond-details/interest-basis`,
      bondPaymentFrequencies: `${coreApiServerUrl}/v4/entities/securities/bond-details/payment-frequencies`,
      securityMarketDividends: `${coreApiServerUrl}/v4/entities/security-markets/{securityMarketId}/dividends`,
      securityDividendTypes: `${coreApiServerUrl}/v4/entities/securities/dividend-types`,
      securityDividendFrequencies: `${coreApiServerUrl}/v4/entities/securities/dividend-frequencies`,
      assetTypesV3: `${coreApiServerUrl}/v3/entities/asset_types`,
      sapiAuth: `${coreApiServerUrl}/v3/entities/sapi_auth`,
      sapiAuthStatus: `${coreApiServerUrl}/v3/entities/sapi_auth/{id}`,
      rebalancingCalculate: `${coreApiServerUrl}/Modeling/calculate`,
      rebalanceTemplates: `${coreApiServerUrl}/rebalancing-templates`,
      rebalanceTemplate: `${coreApiServerUrl}/rebalancing-templates/{id}`,
      rebalancings: `${coreApiServerUrl}/v4/rebalancings`,
      rebalancing: `${coreApiServerUrl}/v4/rebalancings/{id}`,
      rebalancingPortfolioWeights: `${coreApiServerUrl}/v4/rebalancings/portfolio-weights`,
      rebalancingsPending: `${coreApiServerUrl}/v4/rebalancings/pending`,
      rebalancingCalculateAndSaveSecuritiesQuantity: `${coreApiServerUrl}/v4/rebalancings/calculate-and-save-securities-quantity`,
      rebalancingCalculateAndSaveSecurityTargetPct: `${coreApiServerUrl}/v4/rebalancings/calculate-and-save-security-targetpct`,
      rebalancingCalculateAndSavePortfolio: `${coreApiServerUrl}/v4/rebalancings/calculate-and-save-portfolio`,
      rebalancingSaveInputs: `${coreApiServerUrl}/v4/rebalancings/save-inputs`,
      rebalancingStage: `${coreApiServerUrl}/v4/rebalancings/stage`,
      rebalancingCompleted: `${coreApiServerUrl}/v4/rebalancings/completed`,
      rebalancingCashBalance: `${coreApiServerUrl}/v4/rebalancings/cash-balance/{id}`,
      rebalancingNavsWithExposure: `${coreApiServerUrl}/v4/oms/navs/with-exposure`,
      rebalancingUserSettingsV3: `${coreApiServerUrl}/v3/entities/rebalancing_user_settings`,
      pricingRealtimePriceOverrides: `${coreApiServerUrl}/v4/entities/pricing/realtime-price-override`,
      pricingRealtimePriceOverride: `${coreApiServerUrl}/v4/entities/pricing/realtime-price-override/{id}`,
      pricingClosePriceOverride: `${coreApiServerUrl}/v4/entities/pricing/prev-close-price-override`,
      benchmarkIndexIntradayPerformanceV3: `${coreApiServerUrl}/v3/entities/index_intraday_performance`,
      benchmarkAccountIntradayPerformanceV3: `${coreApiServerUrl}/v3/entities/account_intraday_performance`,
      positionBaseV3: `${coreApiServerUrl}/v3/entities/position_base`,
      pmsRebalanceConfigV3: `${coreApiServerUrl}/v3/entities/pms_rebalance_config`,
      pmsUserSettingsV3: `${coreApiServerUrl}/v3/entities/pms_user_settings`,
      pmsPositionsV3: `${coreApiServerUrl}/v3/entities/pms_positions`,
      portfolioLatestPricesV3: `${coreApiServerUrl}/v3/entities/portfolio_latest_prices`,
      pnlDiffPerSecurity: `${coreApiServerUrl}/v4/entities/pnl_diff_per_security`,
      pmsColumns: `${coreApiServerUrl}/v4/pms/columns`,
      boxedPositions: `${coreApiServerUrl}/v4/oms/portfolio/boxed-positions`,
      pmsAccountCashLatest: `${coreApiServerUrl}/v4/oms/cash/latest`,
      performanceTableAggregated: `${coreApiServerUrl}/performance/table/aggregated`,
      performanceTableDetailed: `${coreApiServerUrl}/performance/table/detailed`,
      performanceSummary: `${coreApiServerUrl}/performance/summary`,
      performanceNavChangeDetails: `${coreApiServerUrl}/performance/nav-change-details`,
      orders: `${coreApiServerUrl}/v4/entities/orders`,
      order: `${coreApiServerUrl}/v4/entities/orders/{id}`,
      ordersSearch: `${coreApiServerUrl}/v4/entities/orders/search`,
      ordersBulkRouting: `${coreApiServerUrl}/v4/entities/orders/bulk-routing`,
      placements: `${coreApiServerUrl}/v4/entities/placements`,
      placement: `${coreApiServerUrl}/v4/entities/placements/{id}`,
      orderAllocations: `${coreApiServerUrl}/v4/entities/orders/{orderId}/allocations`,
      orderAllocationsV3: `${coreApiServerUrl}/entities/order_allocations`,
      omsTrades: `${coreApiServerUrl}/v4/trades`,
      omsTrade: `${coreApiServerUrl}/v4/trades/{id}`,
      omsTradesSearch: `${coreApiServerUrl}/v4/trades/search`,
      omsConfig: `${coreApiServerUrl}/v4/oms/config`,
      positionReconciliation: `${coreApiServerUrl}/v4/oms/position-reconciliation`,
      counterparties: `${coreApiServerUrl}/v4/oms/counterparties`,
      counterparty: `${coreApiServerUrl}/v4/oms/counterparties/{counterpartiesType}`,
      counterpartyCustodians: `${coreApiServerUrl}/v4/oms/counterparties/custodians`,
      marketsV3: `${coreApiServerUrl}/v3/entities/markets`,
      marketMostRecentFolder: `${coreApiServerUrl}/v4/markets/{id}/folders/most-recent`,
      folderValues: `${coreApiServerUrl}/v4/oms/folders`,
      folderValue: `${coreApiServerUrl}/v4/oms/folders/{id}`,
      folderValueAffectedTrades: `${coreApiServerUrl}/v4/oms/folders/{id}/affected-trades`,
      folderDefinitions: `${coreApiServerUrl}/v4/oms/folders/definitions`,
      folderDefinition: `${coreApiServerUrl}/v4/oms/folders/definitions/{fieldNumber}`,
      folderDefinitionOptions: `${coreApiServerUrl}/v4/oms/folders/definitions/{fieldNumber}/options`,
      folderDefinitionOptionAffectedFolders: `${coreApiServerUrl}/v4/oms/folders/definitions/{fieldNumber}/options/affected-folders`,
      omsFolderComments: `${coreApiServerUrl}/v4/oms/folder-comments`,
      omsFolderComment: `${coreApiServerUrl}/v4/oms/folder-comments/{id}`,
      folderCommentsV3: `${coreApiServerUrl}/v3/entities/folder_comments`,
      folderCommentV3: `${coreApiServerUrl}/v3/entities/folder_comments/{id}`,
      securityMarketQuote: `${coreApiServerUrl}/v4/entities/security-markets/{securityMarketId}/quote`,
      pmsQuantitiesWeights: `${pinnaklApiUrl}/v1/pms/quantities/weights`,
      pmsQuantitiesTargets: `${pinnaklApiUrl}/v1/pms/quantities/targets`,
      emsUserSettingsV3: `${coreApiServerUrl}/v3/entities/ems_user_settings`,
      emsOrderPtcValidate: `${coreApiServerUrl}/v4/entities/orders/ptc-validate`,
      emsOrderHotkeys: `${coreApiServerUrl}/v4/entities/orders/hotkeys`,
      emsOrderHotkey: `${coreApiServerUrl}/v4/entities/orders/hotkeys/{id}`,
      emsConfig: `${coreApiServerUrl}/v4/entities/ems_config`,
      folderConcept: `${coreApiServerUrl}/v4/oms/folders/concept`,
      configurationOmsConfig: `${coreApiServerUrl}/v4/oms/config`,
      cashBalancesEod: `${coreApiServerUrl}/v4/oms/cash/eod`,
      cashBalanceEod: `${coreApiServerUrl}/v4/oms/cash/eod/{id}`,
      cashBalancesAdjustment: `${coreApiServerUrl}/v4/oms/cash/adjustment`,
      configurationAumsEod: `${coreApiServerUrl}/v4/oms/navs/eod`,
      configurationAumEod: `${coreApiServerUrl}/v4/oms/navs/eod/{id}`,
      brokersV3: `${coreApiServerUrl}/v3/entities/brokers`,
      brokerV3: `${coreApiServerUrl}/v3/entities/brokers/{id}`,
      brokersV4: `${coreApiServerUrl}/v4/brokers`,
      brokerCommissionSchedules: `${coreApiServerUrl}/entities/broker_comm_schedules`,
      brokerCommissionSchedule: `${coreApiServerUrl}/entities/broker_comm_schedules/{id}`,
      brokerCommissionScheduleRules: `${coreApiServerUrl}/entities/broker_comm_sched_rules`,
      brokerCommissionScheduleRule: `${coreApiServerUrl}/entities/broker_comm_sched_rules/{id}`,
      brokerIdentificationIds: `${coreApiServerUrl}/entities/broker_identification_Id`,
      brokerIdentificationId: `${coreApiServerUrl}/entities/broker_identification_Id/{id}`,
      brokerIdentificationTypes: `${coreApiServerUrl}/entities/broker_identification_types`,
      brokerMatchingCommissions: `${coreApiServerUrl}/v4/oms/commissions`,
      commissionSchedulePredicatesV3: `${coreApiServerUrl}/v3/entities/commission_schedule_predicates`,
      brokerOutsourcedDestinationsV3: `${coreApiServerUrl}/v3/entities/broker_outsourced_destinations`,
      brokerOutsourcedDestinationV3: `${coreApiServerUrl}/v3/entities/broker_outsourced_destinations/{id}`,
      brokerEmails: `${coreApiServerUrl}/entities/broker_emails`,
      brokerEmail: `${coreApiServerUrl}/entities/broker_emails/{id}`,
      countries: `${coreApiServerUrl}/entities/countries`,
      country: `${coreApiServerUrl}/entities/countries/{id}`,
      fxRatesCurrenciesLatestV3: `${coreApiServerUrl}/v3/entities/fx_rates_currencies_latest`,
      crmIrAccountingFundsAum: `${coreApiServerUrl}/v4/crm/ir/accounting-funds/aum`,
      crmIrAccountingFundsAumAll: `${coreApiServerUrl}/v4/crm/ir/accounting-funds/aum/all`,
      crmIrAccountingFundsAumItem: `${coreApiServerUrl}/v4/crm/ir/accounting-funds/aum/{id}`,
      crmIrAccountingFundAumPartitions: `${coreApiServerUrl}/v4/crm/ir/accounting-funds/aum/{fundId}/fund-partitions`,
      crmIrAccountingFundsAumSearch: `${coreApiServerUrl}/v4/crm/ir/accounting-funds/aum/search`,
      crmIrAccountingFunds: `${coreApiServerUrl}/v4/crm/ir/accounting-funds`,
      crmIrAccountingFund: `${coreApiServerUrl}/v4/crm/ir/accounting-funds/{id}`,
      crmIrAccountingFundAffected: `${coreApiServerUrl}/v4/crm/ir/accounting-funds/{id}/affected`,
      crmIrFeeTerms: `${coreApiServerUrl}/v4/crm/ir/fee-terms`,
      crmIrFeeTerm: `${coreApiServerUrl}/v4/crm/ir/fee-terms/{id}`,
      crmIrFeeTermAffected: `${coreApiServerUrl}/v4/crm/ir/fee-terms/{id}/affected`,
      crmIrDashboard: `${coreApiServerUrl}/v4/crm/ir/dashboard`,
      crmIrMonthlyAccountData: `${coreApiServerUrl}/v4/crm/ir/monthly-acct-data`,
      crmIrMonthlyAccountDataMostRecent: `${coreApiServerUrl}/v4/crm/ir/monthly-acct-data/most-recent`,
      crmTargetFunds: `${coreApiServerUrl}/v4/crm/target-funds`,
      crmTargetFundSummary: `${coreApiServerUrl}/v4/crm/target-funds/{fundId}/summary`,
      crmTargetFundReturns: `${coreApiServerUrl}/v4/crm/target-funds/{fundId}/returns`,
      crmTargetFundReturn: `${coreApiServerUrl}/v4/crm/target-funds/{fundId}/return`,
      crmTargetFundReturnsDistribution: `${coreApiServerUrl}/v4/crm/target-funds/{fundId}/returns-distribution`,
      crmFundPerformanceBenchmarks: `${coreApiServerUrl}/v4/crm/fund-performance/benchmarks`,
      crmFundPerformanceBenchmarksAll: `${coreApiServerUrl}/v4/crm/fund-performance/benchmarks/all`,
      crmFundPerformanceBenchmarksClient: `${coreApiServerUrl}/v4/crm/fund-performance/benchmarks/client`,
      crmFundPerformanceBenchmarkReturns: `${coreApiServerUrl}/v4/crm/fund-performance/benchmarks/{benchMarkId}/returns`,
      crmFundPerformanceStatsBenchmarks: `${coreApiServerUrl}/v4/crm/fund-performance/stats/benchmarks`,
      crmFundPerformanceStatsTargetFunds: `${coreApiServerUrl}/v4/crm/fund-performance/stats/targetFunds`,
      dedicatedInvestorPortalHome: `${coreApiServerUrl}/v4/dedicated-investor-portal/home`,
      wikiTags: `${coreApiServerUrl}/v4/crm/notes/tags`,
      wikiTag: `${coreApiServerUrl}/v4/crm/notes/tags/{id}`,
      wikiNotes: `${coreApiServerUrl}/v4/crm/notes`,
      wikiNote: `${coreApiServerUrl}/v4/crm/notes/{id}`,
      wikiNoteCategory: `${coreApiServerUrl}/v4/crm/notes/categories/{categoryId}`,
      wikiNoteTags: `${coreApiServerUrl}/v4/crm/notes/{noteId}/tags`,
      wikiNoteTargetFunds: `${coreApiServerUrl}/v4/crm/notes/{noteId}/target-funds`,
      wikiCategories: `${coreApiServerUrl}/v4/crm/notes/categories`,
      wikiCategory: `${coreApiServerUrl}/v4/crm/notes/categories/{id}`,
      crmTaskSuggestions: `${coreApiServerUrl}/v4/crm/task-suggestions`,
      crmTaskSuggestion: `${coreApiServerUrl}/v4/crm/task-suggestions/{id}`,
      crmTaskSuggestionTasks: `${coreApiServerUrl}/v4/crm/task-suggestions/tasks`,
      crmTaskSuggestionsByIds: `${coreApiServerUrl}/v4/crm/task-suggestions/by-ids`,
      crmTasks: `${coreApiServerUrl}/v4/crm/tasks`,
      crmTask: `${coreApiServerUrl}/v4/crm/tasks/{taskId}`,
      crmTasksSearch: `${coreApiServerUrl}/v4/crm/tasks/search`,
      crmSubTasks: `${coreApiServerUrl}/v4/crm/tasks/{taskId}/sub-tasks`,
      crmSubTask: `${coreApiServerUrl}/v4/crm/tasks/{taskId}/sub-tasks/{subTaskId}`,
      crmTargetFund: `${coreApiServerUrl}/v4/crm/target-funds/{id}`,
      crmTargetFundAffectedInvestors: `${coreApiServerUrl}/v4/crm/target-funds/{id}/affected-investors`,
      crmStatusTypes: `${coreApiServerUrl}/v4/crm/status-types`,
      crmStatusType: `${coreApiServerUrl}/v4/crm/status-types/{id}`,
      crmStatusTypeAffectedInvestors: `${coreApiServerUrl}/v4/crm/status-types/{id}/affected-investors`,
      crmWorkspaces: `${coreApiServerUrl}/v4/workspaces`,
      crmOrganizations: `${coreApiServerUrl}/v3/entities/crm_organizations`,
      crmOrganization: `${coreApiServerUrl}/v3/entities/crm_organizations/{id}`,
      crmOrganizationCommunicationTotals: `${coreApiServerUrl}/v3/entities/crm_organizations/{organizationId}/communication-totals`,
      crmOrganizationsPaged: `${coreApiServerUrl}/v3/entities/crm_organizations/paged`,
      crmOrganizationsBulkUpdate: `${coreApiServerUrl}/v3/entities/crm_organizations/bulk-update`,
      crmOrganizationsBulkUpdateByQuery: `${coreApiServerUrl}/v3/entities/crm_organizations/bulk-update-by-query`,
      crmOrganizationsByCreatedDate: `${coreApiServerUrl}/v3/entities/crm_organizations/by-created-date`,
      crmOrganizationsByQuery: `${coreApiServerUrl}/v3/entities/crm_organizations/by-query`,
      crmOrganizationsMerge: `${coreApiServerUrl}/v4/crm/organizations/merge`,
      crmV4Organization: `${coreApiServerUrl}/v4/crm/organizations/{id}`,
      crmOrganizationSummaries: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/summaries`,
      crmOrganizationGenerateSummary: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/generate-summary`,
      crmOrganizationAiSummary: `${coreApiServerUrl}/v4/crm/organizations/{orgId}/summary`,
      crmOrganizationContactAiSummary: `${coreApiServerUrl}/v4/crm/organizations/{orgId}/contacts/{contactId}/summary`,
      crmOrganizationContactGenerateSummary: `${coreApiServerUrl}/v4/crm/organizations/{orgId}/contacts/{contactId}/generate-summary`,
      crmAiChatDataSources: `${coreApiServerUrl}/v4/crm-ai-chats/data-sources`,
      crmOrganizationAiChats: `${coreApiServerUrl}/v4/crm/organizations/{orgId}/ai-chats`,
      crmOrganizationAiChat: `${coreApiServerUrl}/v4/crm/organizations/{orgId}/ai-chats/{chatId}`,
      crmOrganizationAiChatMessages: `${coreApiServerUrl}/v4/crm/organizations/{orgId}/ai-chats/{chatId}/messages`,
      crmOrganizationContacts: `${coreApiServerUrl}/v3/entities/crm_organizations/{id}/contacts`,
      crmOrganizationContact: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/contact/{contactId}`,
      crmOrganizationContactPrimary: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/contact/{contactId}/primary`,
      crmOrganizationRelationships: `${coreApiServerUrl}/v4/crm/organizations/relationships`,
      crmOrganizationRelationship: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/relationship`,
      crmOrganizationLinkedRelationships: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/relationships`,
      crmOrganizationLinkedRelationship: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/relationships/{destinationOrganizationId}`,
      crmOrganizationInvestorTypes: `${coreApiServerUrl}/v4/crm/investor-types`,
      crmOrganizationInvestorType: `${coreApiServerUrl}/v4/crm/investor-types/{investorTypeId}`,
      crmOrganizationInvestorTypeStats: `${coreApiServerUrl}/v4/crm/investor-types/stats`,
      crmOrganizationDocuments: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/documents`,
      crmOrganizationHistoricalTotalBalances: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/historical-total-balances`,
      crmOrganizationCampaignSentActivity: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/campaign-sent-activity`,
      crmOrganizationCampaignOpenActivity: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/campaign-open-activity`,
      crmOrganizationCampaignClickActivity: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/campaign-click-activity`,
      crmOrganizationAuditTrail: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/audit-trail`,
      crmOrganizationGpDetails: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/gp-details`,
      crmOrganizationGpFunds: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/gp-funds`,
      crmOrganizationGpFund: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/gp-funds/{id}`,
      crmGpFundStatuses: `${coreApiServerUrl}/v4/crm/gp-fund-statuses`,
      crmGpFundDomicileJurisdictions: `${coreApiServerUrl}/v4/crm/gp-fund-domicile-jurisdictions`,
      crmGpFundLegalStructures: `${coreApiServerUrl}/v4/crm/gp-fund-legal-structures`,
      crmContactsV3: `${coreApiServerUrl}/v3/entities/contacts`,
      crmContactV3: `${coreApiServerUrl}/v3/entities/contacts/{id}`,
      crmContactCommunicationTotals: `${coreApiServerUrl}/v3/entities/contacts/{id}/communication-totals`,
      crmContactCampaignSentActivity: `${coreApiServerUrl}/v3/entities/contacts/{id}/campaign-sent-activity`,
      crmContactCampaignOpenActivity: `${coreApiServerUrl}/v3/entities/contacts/{id}/campaign-open-activity`,
      crmContactCampaignClickActivity: `${coreApiServerUrl}/v3/entities/contacts/{id}/campaign-click-activity`,
      crmContactCollectCommunications: `${coreApiServerUrl}/v3/entities/contacts/{id}/collect-communications`,
      crmContactCollectCommunicationsPreview: `${coreApiServerUrl}/v3/entities/contacts/{id}/collect-communications/preview`,
      crmContactsPaged: `${coreApiServerUrl}/v3/entities/contacts/paged`,
      crmContactsCount: `${coreApiServerUrl}/v3/entities/contacts/count`,
      crmContactsRecentlyCreated: `${coreApiServerUrl}/v3/entities/contacts/recently-created`,
      crmContactsMerge: `${coreApiServerUrl}/v4/crm/contacts/merge`,
      crmContactsLegacy: `${coreApiServerUrl}/entities/crm_contacts`,
      crmPhones: `${coreApiServerUrl}/entities/crm_phones`,
      crmEmailAddresses: `${coreApiServerUrl}/entities/crm_email_addresses`,
      crmContactsProximitySearch: `${coreApiServerUrl}/v4/crm/contacts/proximity-search`,
      crmContactRelatedInvestorAccounts: `${coreApiServerUrl}/v4/crm/ir/investor-accounts/contacts/{contactId}/related-investor-accounts`,
      crmContactsMigrate: `${coreApiServerUrl}/v3/entities/contacts/migrate`,
      crmContactAuditTrail: `${coreApiServerUrl}/v4/crm/contacts/{contactId}/audit-trail`,
      crmInvestors: `${coreApiServerUrl}/entities/crm_investors`,
      crmRecentlyVisitedInvestors: `${coreApiServerUrl}/entities/crm_recently_visited_investors`,
      crmInvestorStatusTypes: `${coreApiServerUrl}/entities/crm_investor_status_types`,
      crmClientInvestorReturnMappingV3: `${coreApiServerUrl}/v3/entities/crm_client_investor_return_mapping`,
      crmInvestorPostalAddresses: `${coreApiServerUrl}/entities/crm_investor_postal_addresses`,
      crmInvestorContacts: `${coreApiServerUrl}/entities/crm_investor_contacts`,
      crmInvestorContact: `${coreApiServerUrl}/entities/crm_investor_contacts/{id}`,
      crmDakotaContacts: `${coreApiServerUrl}/v4/crm/dakota/contacts`,
      crmDakotaOrganizations: `${coreApiServerUrl}/v4/crm/dakota/organizations`,
      crmDakotaOrganizationsBatch: `${coreApiServerUrl}/v4/crm/dakota/organizations-batch`,
      crmDakotaFieldOptions: `${coreApiServerUrl}/v4/crm/dakota/field-options`,
      crmDakotaFieldOptionsNames: `${coreApiServerUrl}/v4/crm/dakota/field-options-names`,
      crmOrganizationMonthlyBalancesSearch: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/monthly-balances/search`,
      crmOrganizationMigrations: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/migrations`,
      crmOrganizationInvestorAccounts: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/investor-accounts`,
      crmOrganizationCapitalActivitySearch: `${coreApiServerUrl}/v4/crm/organizations/{organizationId}/capital-activity/search`,
      crmIrCapitalActivities: `${coreApiServerUrl}/v4/crm/ir/capital-activity`,
      crmIrCapitalActivity: `${coreApiServerUrl}/v4/crm/ir/capital-activity/{id}`,
      crmIrCapitalActivityFile: `${coreApiServerUrl}/v4/crm/ir/capital-activity/{activityId}/files/{fileId}`,
      crmIrCapitalActivitiesSearch: `${coreApiServerUrl}/v4/crm/ir/capital-activity/search`,
      crmIrCapitalActivityTransactionTypes: `${coreApiServerUrl}/v4/crm/ir/capital-activity/transaction-types`,
      crmIrCapitalActivityTransactionType: `${coreApiServerUrl}/v4/crm/ir/capital-activity/transaction-types/{id}`,
      crmIrCapitalActivityTransactionTypeCanDelete: `${coreApiServerUrl}/v4/crm/ir/capital-activity/transaction-types/{id}/can-delete`,
      crmIrSideLetterCategories: `${coreApiServerUrl}/v4/crm/ir/side-letter`,
      crmIrSideLetterCategory: `${coreApiServerUrl}/v4/crm/ir/side-letter/{id}`,
      crmIrSideLetterCategoryClauses: `${coreApiServerUrl}/v4/crm/ir/side-letter/{categoryId}/clauses`,
      crmIrSideLetterCategoryClause: `${coreApiServerUrl}/v4/crm/ir/side-letter/{categoryId}/clauses/{id}`,
      crmIrSideLetterTriggers: `${coreApiServerUrl}/v4/crm/ir/side-letter/triggers`,
      crmIrSideLetterTrigger: `${coreApiServerUrl}/v4/crm/ir/side-letter/triggers/{id}`,
      crmIrSideLetterClauseTriggers: `${coreApiServerUrl}/v4/crm/ir/side-letter/{clauseId}/triggers`,
      crmIrSideLetterClauseNotifications: `${coreApiServerUrl}/v4/crm/ir/side-letter/clauses/{clauseId}/notifications`,
      crmIrSideLetterNotification: `${coreApiServerUrl}/v4/crm/ir/side-letter/clauses/notifications/{notificationId}`,
      crmIrInvestorAccounts: `${coreApiServerUrl}/v4/crm/ir/investor-accounts`,
      crmIrInvestorAccount: `${coreApiServerUrl}/v4/crm/ir/investor-accounts/{id}`,
      crmIrInvestorAccountsPaged: `${coreApiServerUrl}/v4/crm/ir/investor-accounts/paged`,
      crmIrInvestorAccountMigration: `${coreApiServerUrl}/v4/crm/ir/investor-accounts/{investorAccountId}/migrate`,
      crmIrInvestorAccountContacts: `${coreApiServerUrl}/v4/crm/ir/investor-accounts/{investorAccountId}/contacts`,
      crmIrInvestorAccountContact: `${coreApiServerUrl}/v4/crm/ir/investor-accounts/{investorAccountId}/contacts/{contactId}`,
      crmInvestorAccountRegulatoryFillingsV3: `${coreApiServerUrl}/v3/entities/crm_investor_accounts_reg_filings_info`,
      crmInvestorAccountAmlV3: `${coreApiServerUrl}/v3/entities/crm_investor_account_aml`,
      crmInvestorAccountTaxV3: `${coreApiServerUrl}/v3/entities/crm_investor_account_tax`,
      crmRegAmlFieldOptionsV3: `${coreApiServerUrl}/v3/entities/crm_reg_aml_fieldoptions`,
      crmInvestorAccountTaxFieldOptionsV3: `${coreApiServerUrl}/v3/entities/crm_investor_accounts_tax_fieldoptions`,
      crmIrMonthlyBalanceColumns: `${coreApiServerUrl}/v4/crm/ir/balances/field-mapping`,
      crmIrMonthlyBalances: `${coreApiServerUrl}/v4/crm/ir/monthly-balances`,
      crmIrMonthlyBalancesCount: `${coreApiServerUrl}/v4/crm/ir/monthly-balances/count`,
      crmIrMonthlyBalancesSearch: `${coreApiServerUrl}/v4/crm/ir/monthly-balances/search`,
      crmSearchRecent: `${coreApiServerUrl}/v4/crm/search/recent`,
      crmSearchRecentItem: `${coreApiServerUrl}/v4/crm/search/recent/{id}`,
      bulkUploadImport: `${coreApiServerUrl}/v4/bulk-upload/import`,
      bulkUploadImportTemplates: `${coreApiServerUrl}/v4/bulk-upload/import/templates`,
      bulkUploadImportFile: `${coreApiServerUrl}/v4/bulk-upload/import/{fileId}`,
      bulkUploadImportFileRevert: `${coreApiServerUrl}/v4/bulk-upload/import/{fileId}/revert`,
      bulkUploadImportFileProcess: `${coreApiServerUrl}/v4/bulk-upload/import/{fileId}/process`,
      crmEmailCampaignTrackingLinksV4: `${coreApiServerUrl}/v4/crm/email-campaign/tracking-links`,
      crmEmailCampaignTrackingLinkV4: `${coreApiServerUrl}/v4/crm/email-campaign/tracking-links/{id}`,
      crmEmailCampaignTemplates: `${coreApiServerUrl}/v4/crm/email-campaign/templates`,
      crmEmailCampaignTemplate: `${coreApiServerUrl}/v4/crm/email-campaign/templates/{id}`,
      crmEmailCampaigns: `${coreApiServerUrl}/v4/crm/email-campaigns`,
      crmEmailCampaign: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}`,
      crmEmailCampaignTabsCount: `${coreApiServerUrl}/v4/crm/email-campaigns/tabs-count`,
      crmEmailCampaignValidate: `${coreApiServerUrl}/v4/crm/email-campaigns/validate`,
      crmEmailCampaignTest: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/test`,
      crmEmailCampaignSend: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/send`,
      crmEmailCampaignSchedule: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/schedule`,
      crmEmailCampaignDocuments: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/documents`,
      crmEmailCampaignDocument: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/document/{documentId}`,
      crmEmailCampaignContacts: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contacts`,
      crmEmailCampaignContactsIncludedPaged: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contacts/included/paged`,
      crmEmailCampaignContactsRemovedPaged: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contacts/removed/paged`,
      crmEmailCampaignContactsAvailablePaged: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contacts/available/paged`,
      crmEmailCampaignContactsInclude: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contacts/include`,
      crmEmailCampaignContactsExclude: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contacts/exclude`,
      crmEmailCampaignContactsRemovedClear: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contacts/removed/clear`,
      crmEmailCampaignContactEngagement: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}/contact-engagement`,
      crmEmailCampaignCategories: `${coreApiServerUrl}/v4/crm/email-campaign/categories`,
      crmEmailCampaignCategory: `${coreApiServerUrl}/v4/crm/email-campaign/categories/{id}`,
      crmEmailCampaignCategoryAffected: `${coreApiServerUrl}/v4/crm/email-campaign/categories/{id}/affected`,
      crmEmailCampaignTesters: `${coreApiServerUrl}/v4/crm/email-campaigns/testers`,
      crmEmailCampaignTester: `${coreApiServerUrl}/v4/crm/email-campaigns/testers/{id}`,
      crmEmailCampaignDistributionLists: `${coreApiServerUrl}/v4/crm/email-campaign/distribution-lists`,
      crmEmailCampaignDistributionList: `${coreApiServerUrl}/v4/crm/email-campaign/distribution-lists/{id}`,
      crmEmailCampaignDistributionListDuplicate: `${coreApiServerUrl}/v4/crm/email-campaign/distribution-lists/{id}/duplicate`,
      crmEmailCampaignDistributionListContacts: `${coreApiServerUrl}/v4/crm/email-campaign/distribution-lists/{id}/contacts`,
      crmEmailCampaignDistributionListContactsBulkUpdateByQuery: `${coreApiServerUrl}/v4/crm/email-campaign/distribution-lists/{id}/contacts/bulk-update-by-query`,
      crmLegacyDistributionList: `${coreApiServerUrl}/entities/crm_dist_lists/{id}`,
      crmSentEmailCampaign: `${coreApiServerUrl}/v4/crm/email-campaigns/{id}`,
      crmSentEmailCampaignOpenActivity: `${coreApiServerUrl}/v4/crm/email-campaigns/{sentEmailCampaignId}/open-activity`,
      crmSentEmailCampaignClickActivity: `${coreApiServerUrl}/v4/crm/email-campaigns/{sentEmailCampaignId}/click-activity`,
      crmSentEmailCampaignSummaryStats: `${coreApiServerUrl}/v4/crm/email-campaigns/{sentEmailCampaignId}/summary-stats`,
      crmDeals: `${coreApiServerUrl}/v4/crm/deals`,
      crmDeal: `${coreApiServerUrl}/v4/crm/deals/{id}`,
      crmDealRelatedOrganization: `${coreApiServerUrl}/v4/crm/deals/related-organization`,
      crmDealPipelines: `${coreApiServerUrl}/v4/crm/deal-pipelines`,
      crmDealPipeline: `${coreApiServerUrl}/v4/crm/deal-pipelines/{id}`,
      crmDealPipelineStats: `${coreApiServerUrl}/v4/crm/deal-pipelines/{pipelineId}/stats`,
      crmDealPipelineDeals: `${coreApiServerUrl}/v4/crm/deal-pipelines/{pipelineId}/deals`,
      crmDealPipelineStages: `${coreApiServerUrl}/v4/crm/deal-pipelines/{pipelineId}/stages`,
      crmDealPipelineStage: `${coreApiServerUrl}/v4/crm/deal-pipelines/{pipelineId}/stages/{id}`,
      crmDealPipelineStagesReorder: `${coreApiServerUrl}/v4/crm/deal-pipelines/{pipelineId}/stages/reorder`,
      crmDealLossReasons: `${coreApiServerUrl}/v4/crm/deal-loss-reasons`,
      crmDealLossReason: `${coreApiServerUrl}/v4/crm/deal-loss-reasons/{id}`,
      crmDealLossReasonAffectedDeals: `${coreApiServerUrl}/v4/crm/deal-loss-reasons/{id}/affected-deals`,
      crmGpDropdownOptions: `${coreApiServerUrl}/v4/crm/gp-dropdown-options`,
      crmGpDropdownOption: `${coreApiServerUrl}/v4/crm/gp-dropdown-options/{id}`,
      crmGpDropdownOptionTypes: `${coreApiServerUrl}/v4/crm/gp-dropdown-options/types`,
      crmDashboardEntitiesCount: `${coreApiServerUrl}/v4/crm/dashboard/entities-count`,
      crmDashboardPortalAnalyticsSummary: `${coreApiServerUrl}/v4/crm/portal/analytics/overall-summary`,
      crmDashboardChartingFields: `${coreApiServerUrl}/v4/crm/dashboard/charting-fields`,
      crmDashboardOrganizationsCountStaticField: `${coreApiServerUrl}/v4/crm/dashboard/organizations-count-static-field`,
      crmDashboardOrganizationsCountCustomField: `${coreApiServerUrl}/v4/crm/dashboard/organizations-count-custom-field`,
      crmDashboardRecentEmailCampaignStats: `${coreApiServerUrl}/v4/crm/dashboard/recent-email-campaign-stats`,
      crmDashboardActivitySummary: `${coreApiServerUrl}/v4/crm/dashboard/activity-summary`,
      crmDashboardDealsSummary: `${coreApiServerUrl}/v4/crm/dashboard/deals-summary`,
      crmDashboardOrganizationCategoryDetails: `${coreApiServerUrl}/v4/crm/dashboard/organization-category-details`,
      crmDashboardCountries: `${coreApiServerUrl}/v4/crm/dashboard/countries`,
      leadChannel: `${coreApiServerUrl}/v4/crm/lead-channels/{id}`,
      leadChannelAffectedInvestors: `${coreApiServerUrl}/v4/crm/lead-channels/{id}/affected-investors`,
      sectorsV4: `${coreApiServerUrl}/v4/entities/sectors`,
      securityPublicIdentifiers: `${coreApiServerUrl}/v4/entities/securities/{securityId}/identifiers`,
      securityOrganizationStatuses: `${coreApiServerUrl}/v4/entities/securities/org-statuses`,
      securityOrganizationStatus: `${coreApiServerUrl}/v4/entities/securities/org-statuses/{id}`,
      authEmailsCollector: `${emailsCollectorUrl}/auth`,
      statusEmailsCollector: `${emailsCollectorUrl}/status`,
      revokeEmailCollector: `${emailsCollectorUrl}/revoke`,
      securityCustomAttributes: `${coreApiServerUrl}/v4/entities/securities/{securityId}/custom-attributes`,
      securityCustomAttribute: `${coreApiServerUrl}/v4/entities/securities/{securityId}/custom-attributes/{id}`,
      portalUser: `${httpServerUrl}/portal/users`,
      portalUserClientConfig: `${httpServerUrl}/portal/users/client-config`,
      portalUserSelectedClient: `${httpServerUrl}/portal/users/selected-client`,
      cashFlows: `${coreApiServerUrl}/entities/cash_flows`,
      cashFlow: `${coreApiServerUrl}/entities/cash_flows/{id}`,
      cashFlowTypes: `${coreApiServerUrl}/entities/cash_flow_types`,
      corporateActionEvents: `${coreApiServerUrl}/entities/corporate_action_events`,
      corporateActionEvent: `${coreApiServerUrl}/entities/corporate_action_events/{id}`,
      corporateActionEventProcessing: `${coreApiServerUrl}/entities/corporate_action_event_processing`,
      corporateActionEventResults: `${coreApiServerUrl}/entities/corporate_action_event_result`,
      corporateActionEventResult: `${coreApiServerUrl}/entities/corporate_action_event_result/{id}`,
      corporateActionEventSources: `${coreApiServerUrl}/entities/corporate_action_event_sources`,
      corporateActionEventTypes: `${coreApiServerUrl}/entities/corporate_action_event_types`,
      dashboardAllData: `${coreApiServerUrl}/entities/webapp_dashboard`,
      dashboardActivitySummary: `${coreApiServerUrl}/entities/portfolio_activity`,
      dashboardTasks: `${coreApiServerUrl}/entities/tasks`,
      dashboardTaskParams: `${coreApiServerUrl}/entities/task_params`,
      dashboardTaskRequests: `${coreApiServerUrl}/entities/task_requests`,
      dashboardTaskStatusDetails: `${coreApiServerUrl}/entities/task_status_details`,
      dashboardTaskStatus: `${coreApiServerUrl}/entities/tasks_status`,
      recommendedActions: `${coreApiServerUrl}/entities/recommended_actions`,
      recommendedActionActivities: `${coreApiServerUrl}/entities/recommended_action_activities`,
      bulkTradeUpload: `${coreApiServerUrl}/v3/entities/bulk_trade_upload`,
      benchmarkComparisons: `${coreApiServerUrl}/entities/benchmark_comparisons`,
      counterPartyExposure: `${coreApiServerUrl}/entities/counter_party_exposure`,
      riskDates: `${coreApiServerUrl}/entities/risk_dates`,
      riskDashboard: `${coreApiServerUrl}/entities/risk_dashboard`,
      riskExposureFields: `${coreApiServerUrl}/entities/risk_exposure_fields`,
      riskLimits: `${coreApiServerUrl}/entities/risk_limits`,
      riskTimeseries: `${coreApiServerUrl}/entities/risk_timeseries`,
      riskClientBenchmarks: `${coreApiServerUrl}/entities/client_benchmarks`,
      riskStressTests: `${coreApiServerUrl}/entities/stress_tests`,
      riskPortfolioCharacteristics: `${coreApiServerUrl}/entities/portfolio_characteristics`,
      tradeRestrictionPredicates: `${coreApiServerUrl}/v3/entities/trade_restriction_predicates`,
      generalLedgerAccounts: `${coreApiServerUrl}/entities/general_ledger_accounts`,
      generalLedgerJournalItems: `${coreApiServerUrl}/entities/general_ledger`,
      generalLedgerChanges: `${coreApiServerUrl}/entities/general_ledger_changes`,
      generalLedgerRecurringExpenses: `${coreApiServerUrl}/entities/general_ledger_recurring_expenses`,
      clients: `${coreApiServerUrl}/v4/clients`,
      presets: `${coreApiServerUrl}/entities/user_module_configs`,
      preset: `${coreApiServerUrl}/entities/user_module_configs/{id}`,
      reports: `${coreApiServerUrl}/v4/reports`,
      reportColumns: `${coreApiServerUrl}/v4/reports/{reportId}/columns`,
      reportParameters: `${coreApiServerUrl}/v4/reports/{reportId}/parameters`,
      vdrPortalUsers: `${coreApiServerUrl}/v4/crm/portal/users`,
      vdrPortalUsersActivate: `${coreApiServerUrl}/v4/crm/portal/users/activate`,
      vdrPortalUsersDeactivate: `${coreApiServerUrl}/v4/crm/portal/users/deactivate`,
      vdrPortalGroups: `${coreApiServerUrl}/v4/crm/portal/groups`,
      vdrPortalGroup: `${coreApiServerUrl}/v4/crm/portal/groups/{id}`,
      vdrRootFolders: `${coreApiServerUrl}/v4/crm/portal/folders/root-folders`,
      dataRoomPortalDocuments: `${coreApiServerUrl}/v4/crm/portal/documents`,
      dataRoomPortalDocument: `${coreApiServerUrl}/v4/crm/portal/documents/id/{id}`,
      dataRoomPortalRecentDocuments: `${coreApiServerUrl}/v4/crm/portal/documents/recent-documents`,
      dataRoomPortalDocumentsSearch: `${coreApiServerUrl}/v4/crm/portal/documents/search`,
      dataRoomPortalDocumentNotificationRecipients: `${coreApiServerUrl}/v4/crm/portal/documents/{fileId}/notification-recipients`,
      dataRoomDocumentNotifications: `${coreApiServerUrl}/file/notifications`,
      dataRoomFolders: `${coreApiServerUrl}/v4/crm/portal/folders`,
      dataRoomFolder: `${coreApiServerUrl}/v4/crm/portal/folders/{id}`,
      dataRoomFolderAccess: `${coreApiServerUrl}/v4/crm/portal/folders/{folderId}/{folderAccess}`,
      dataRoomFolderFile: `${coreApiServerUrl}/v4/crm/portal/folders/{folderId}/files/{fileId}`,
      dataRoomFolderFileDetails: `${coreApiServerUrl}/v4/crm/portal/folders/{folderId}/files/{fileId}/details`,
      crmEmailCampaignTrackingLinks: `${coreApiServerUrl}/v3/entities/crm_emailcampaign_tracking_links`,
      dataRooms: `${coreApiServerUrl}/v4/crm/portal/folders/dataroom`,
      dataRoomsExternal: `${coreApiServerUrl}/v4/crm/portal/folders/dataroom/external`,
      dataRoomsEmailCampaign: `${coreApiServerUrl}/v4/crm/portal/folders/dataroom/email-campaign`,
      dataRoom: `${coreApiServerUrl}/v4/crm/portal/folders/dataroom/{id}`,
      crmPortalConfigs: `${coreApiServerUrl}/v3/entities/crm_portal_config`,
      crmPortalConfig: `${coreApiServerUrl}/v3/entities/crm_portal_config/{id}`,
      vdrAnalyticsSummary: `${coreApiServerUrl}/v4/crm/portal/analytics/overall-summary`,
      vdrAnalyticsActivitiesCount: `${coreApiServerUrl}/v4/crm/portal/analytics/activities-count`,
      vdrAnalyticsMostEngagedUsers: `${coreApiServerUrl}/v4/crm/portal/analytics/most-engaged-users`,
      vdrAnalyticsMostEngagedOrganizations: `${coreApiServerUrl}/v4/crm/portal/analytics/most-engaged-organizations`,
      vdrAnalyticsMostPopularDocuments: `${coreApiServerUrl}/v4/crm/portal/analytics/most-popular-documents`,
      vdrAnalyticsMostPopularFolders: `${coreApiServerUrl}/v4/crm/portal/analytics/most-popular-folders`,
      vdrAnalyticsUserActivities: `${coreApiServerUrl}/v4/crm/portal/analytics/user-activities`,
      vdrAnalyticsContact: `${coreApiServerUrl}/v4/crm/portal/analytics/contact-analytics`,
      vdrAnalyticsOrganization: `${coreApiServerUrl}/v4/crm/portal/analytics/org-analytics`,
      vdrAnalyticsActivityCount: `${coreApiServerUrl}/v4/crm/portal/analytics/activity-count`,
      vdrAnalyticsUser: `${coreApiServerUrl}/v4/crm/portal/users/{userId}/analytics`,
      vdrAnalyticsDocument: `${coreApiServerUrl}/v4/crm/portal/documents/{documentId}/analytics`,
      watermarkSettingsTemplates: `${coreApiServerUrl}/v4/crm/watermarking/settings/templates`,
      watermarkSettingsTemplate: `${coreApiServerUrl}/v4/crm/watermarking/settings/templates/{id}`,
      watermarkSettingsTemplateCanDelete: `${coreApiServerUrl}/v4/crm/watermarking/settings/templates/{id}/can-delete`,
      watermarkSettingsDefault: `${coreApiServerUrl}/v4/crm/watermarking/settings/default`,
      watermarkSettingsFonts: `${coreApiServerUrl}/v4/crm/watermarking/settings/watermark-fonts`,
      vdrConfiguration: `${coreApiServerUrl}/v4/crm/config/investor-portal`,
      notificationTopics: `${pinnaklApiUrl}/v1/notifications/topics`,
      notificationSubscribers: `${pinnaklApiUrl}/v1/notifications/subscribers`,
      notificationSubscriber: `${pinnaklApiUrl}/v1/notifications/subscribers/{recipientId}`,
      notificationSubscriberSubscriptions: `${pinnaklApiUrl}/v1/notifications/subscribers/{recipientId}/subscriptions`,
      teams: `${coreApiServerUrl}/v4/teams`,
      team: `${coreApiServerUrl}/v4/teams/{id}`,
      teamUsers: `${coreApiServerUrl}/v4/teams/{teamId}/users`,
      teamUser: `${coreApiServerUrl}/v4/teams/{teamId}/users/{userId}`,
      internalEmployees: `${coreApiServerUrl}/v4/crm/client-employees`,
      internalEmployee: `${coreApiServerUrl}/v4/crm/client-employees/{id}`,
      internalEmployeeCanDelete: `${coreApiServerUrl}/v4/crm/client-employees/{id}/can-delete`,
      domainExclusions: `${coreApiServerUrl}/v4/crm/domain-exclusion`,
      emailExclusions: `${coreApiServerUrl}/v4/crm/email-exclusions`,
      emailCampaignClientConfiguration: `${pinnaklApiUrl}/v1/notifications/client-configuration`,
      localitiesV3: `${coreApiServerUrl}/v3/entities/localities`,
      crmClientConfig: `${coreApiServerUrl}/v4/crm/config/client`,
      crmOutlookAddinConfig: `${coreApiServerUrl}/v4/crm/config/outlook-addin`,
      crmCanDisableMultipleAssignees: `${coreApiServerUrl}/v4/crm/tasks/can-disable-multiple-assignees`,
      emailCampaignConfig: `${coreApiServerUrl}/v4/crm/config/email-campaigns`,
      emailProviderIntegrationTest: `${coreApiServerUrl}/v4/crm/email-provider-integration/test`,
      blockedIps: `${coreApiServerUrl}/v4/crm/blocked-ips`,
      blockedIp: `${coreApiServerUrl}/v4/crm/blocked-ips/{id}`,
      allUsers: `${coreApiServerUrl}/v4/users/all`,
      aiFeatures: `${coreApiServerUrl}/v4/crm/ai-features`,
      aiFeaturesDisclaimer: `${coreApiServerUrl}/v4/crm/ai-features/disclaimer`,
      aiFeaturesEnabled: `${coreApiServerUrl}/v4/crm/ai-features/enabled`,
      aiFeaturesDisabled: `${coreApiServerUrl}/v4/crm/ai-features/disabled`,
      aiTokenUsagesSummary: `${coreApiServerUrl}/v4/ai-token-usages/summary`,
      aiAgentSettings: `${coreApiServerUrl}/v4/crm/ai-agents/settings`,
      aiAgentSetting: `${coreApiServerUrl}/v4/crm/ai-agents/settings/{agentKey}`,
      userModuleConfigsV4: `${coreApiServerUrl}/v4/user-module-configs`,
      userModuleConfigV4: `${coreApiServerUrl}/v4/user-module-configs/{id}`,
      shareUserModuleConfigsV4: `${coreApiServerUrl}/v4/user-module-configs/share`,
    } as const;
  },
});
